export function inRangeInclusive(n: number, min: number, max: number) {
  return n >= min && n <= max;
}
